export default __webpack_public_path__ + "static/media/chevronLeft_white.224e3fd8.svg";